import { useState } from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { Modal, Button } from '@morressier/alembic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserTag } from '@fortawesome/pro-solid-svg-icons';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  reviewerName: string;
  onReassign: () => Promise<void>;
}

const ReassignBoardMemberModal = ({
  isOpen,
  onClose,
  reviewerName,
  onReassign
}: Props) => {
  const [isProcessing, setIsProcessing] = useState(false);

  const handleReassign = async () => {
    setIsProcessing(true);
    try {
      await onReassign();
      onClose();
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} width="448px">
      <Flex padding={8} gap={4} flexDirection="column">
        <FontAwesomeIcon
          icon={faUserTag}
          style={{ width: '40px', height: '40px' }}
        />
        <Text textStyle="headingGroup">Reassign Reviewer?</Text>
        <Text>
          {reviewerName} will be reassigned to review this submission.
        </Text>

        <Flex gap={2} justifyContent="flex-end">
          <Button onClick={onClose} variant="secondary">
            Cancel
          </Button>
          <Button
            type="submit"
            onClick={handleReassign}
            isLoading={isProcessing}
          >
            Reassign Reviewer
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default ReassignBoardMemberModal;
